import { GET, POST, PUT, DELETE } from "../../api";

export const findAOneUserPercentage = async (data) => {
  return await POST(`/admin/user-percentage-management/get`, data);
};

export const Update = async (data) => {
  return await POST(`/admin/user-percentage-management/update`, data);
};
